// WhatsAppCTA.jsx
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; // Make sure to install react-icons
import './whatapp.css'

const WhatsAppCTA = () => {
  return (
    <a
      href="https://wa.me/919663222146"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-cta"
    >
      <FaWhatsapp size={30} />
    </a>
  );
};

export default WhatsAppCTA;
